"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const internal_1 = require("svelte/internal");
const currentPosition = (start, end, elapsed, duration, easing) => {
    if (elapsed > duration)
        return end;
    return start + (end - start) * easing(elapsed / duration);
};
const smoothScroll = (options, callback) => {
    const { start, end, duration, easing } = options;
    const clock = (0, internal_1.now)();
    const step = () => {
        const elapsed = (0, internal_1.now)() - clock;
        const position = currentPosition(start, end, elapsed, duration, easing);
        callback(position);
        if (elapsed > duration)
            return;
        window.requestAnimationFrame(step);
    };
    window.requestAnimationFrame(step);
};
exports.default = smoothScroll;
